import CacheDashboardApi from "../../services/api/CacheDashboard";
import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";

const handleError = (err) => {
  console.log("[handleError] Error in CacheDashboard actions", err);
}

export const getCache = (key) => async (dispatch) => {
    try{
        dispatch(setLoader(true));
        let response = await CacheDashboardApi.getCache(key);
        const value = {"key" : key, "value" : response.response.redis_value};
        dispatch(setLoader(false));
        return {success: true, data: value};
    } catch (err) {
        dispatch(setLoader(false));
        dispatch(
            setStatus({
                type: "error",
                message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
            })
        );
        handleError(err);
    }
};

export const setCache = (payload) => async (dispatch) => {
    try{
        dispatch(setLoader(true));
        const jsonObj = JSON.parse(payload);
        let response = await CacheDashboardApi.setCache(jsonObj);
        const key = response.response.redis_key;
        const value = response.response.redis_value;
        return {success:true, data:{key, value}};
        dispatch(setLoader(false));
    } catch (err) {
        dispatch(setLoader(false));
        dispatch(
            setStatus({
                type: "error",
                message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
            })
        );
        handleError(err);
    }
}

export const deleteCache = (key) => async (dispatch) => {
    try{
        dispatch(setLoader(true));
        let response = await CacheDashboardApi.deleteCache(key);
        console.log("response", response)
        dispatch(setLoader(false));
        return {success: true, data: response.response};
    } catch (err) {
        dispatch(setLoader(false));
        dispatch(
            setStatus({
                type: "error",
                message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
            })
        );
        handleError(err);
    }
}